interface EmptyStateProps {
  title: string;
  description: string;
  actionLabel?: string;
  onAction?: () => void;
}

export default function EmptyState({ title, description, actionLabel, onAction }: EmptyStateProps) {
  return (
    <div className="rounded-lg border border-dashed border-background-300/80 bg-background-100/50 px-6 py-16 flex flex-col items-center text-center">
      <span className="w-16 h-16 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-900 mb-5">
        <i className="ri-file-search-line text-3xl" aria-hidden="true"></i>
      </span>
      <h3 className="font-heading text-lg text-foreground-950 font-semibold">{title}</h3>
      <p className="mt-2 text-sm text-foreground-600 max-w-md leading-relaxed">{description}</p>
      {actionLabel && onAction && (
        <button
          type="button"
          onClick={onAction}
          className="mt-6 h-10 px-5 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
        >
          {actionLabel}
        </button>
      )}
    </div>
  );
}